import { useCallback } from 'react';

import { useAtomValue } from 'jotai';
import { useLocation } from 'react-router';

import { boothIdAtom, currentSessionIdAtom, currentUserIdAtom } from '@store';

export const EVENT_TYPES = {
    PAGE_VIEW: 'page:view',
} as const;

export const EVENT_CATEGORIES = {
    ERROR: 'error',
    NAVIGATION: 'navigation',
    INTERACTION: 'interaction',
    SYSTEM: 'system',
} as const;

const EVENT_CATEGORIES_MAP = {
    [EVENT_TYPES.PAGE_VIEW]: EVENT_CATEGORIES.NAVIGATION,
};

type EventName = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES];

export const useEventLogs = () => {
    const boothId = useAtomValue(boothIdAtom);
    const userId = useAtomValue(currentUserIdAtom);
    const sessionId = useAtomValue(currentSessionIdAtom);
    const location = useLocation();

    return useCallback((eventName: EventName, source: 'kiosk' | 'floor' | 'home', dedup?: 'session' | 'once') => {
        const eventCategory = EVENT_CATEGORIES_MAP[eventName];
        // eslint-disable-next-line no-console
        console.log('trackEvent', {
            boothId,
            userId,
            sessionId,
            eventCategory,
            eventPage: location.pathname,
            eventName,
            source,
            dedup,
        });
        // Enable when we revisit metrics.

        // trackEvent(supabaseClient, {
        //     boothId,
        //     userId,
        //     sessionId,
        //     eventCategory,
        //     eventPage: location.pathname,
        //     eventName,
        //     source,
        //     dedup,
        // });
    }, []);
};
